export const classificationLabels = {
  KO: "KO",
  VO: "VO",
  AK: "AK",
  VK: "VK",
  V: "V"
};
